import { FC, ChangeEvent } from "react";
import classNames from 'classnames';
import "./style.scss"
import "./style.mobile.scss"

interface CheckboxProps {
  value?: string[];
  onChange?: (e: string[]) => void;
  options: {label: string, value: string}[];
  label?: string
  className?: string
  error?: boolean
}
const Checkbox: FC<CheckboxProps> = ({
  value,
  onChange,
  options,
  label,
  className,
  error,
}) => {
  const handleChange = (field: string, e: ChangeEvent<HTMLInputElement>) => {
    const checked = e.target.checked;
    if (checked) {
      if (value?.includes(field)) {
        return;
      }
      onChange?.([...(value || []), field]);
    } else {
      onChange?.(value?.filter((item) => item !== field) || []);
    }
  };

  return (
    <div className={classNames("checkbox-container", className, { error })}>
      <div className="checkbox-label">{label}</div>
      <ul className="checkbox-group">
        {options.map((item) => (
          <li key={item.value} className="checkbox-item">
            <label>
              <input
                onChange={(e) => handleChange(item.value, e)}
                className="checkbox-input"
                type="checkbox"
                value=""
              />
              <span
                className={classNames("checkbox-status", {
                  checked: value?.includes(item.value),
                })}
              ></span>
              <span className="checkbox-text">{item.label}</span>
            </label>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default Checkbox